const Expenses = () => {
    return (
        <>
            <div className="col-md-12 col-lg-4">
                <div className="row">
                    <div className="col-lg-6 col-md-3 col-6 mb-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="card-title d-flex align-items-start justify-content-between">
                                    <div className="avatar flex-shrink-0">
                                        <img src="../../iusevolutione/assets/img/icons/unicons/wallet-info.png" alt="Credit Card" className="rounded" />
                                    </div>
                                    <div className="dropdown">
                                        <button className="btn p-0" type="button" id="cardOpt6" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="bx bx-dots-vertical-rounded" />
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="cardOpt6">
                                            <a className="dropdown-item" href="javascript:void(0);">View More</a>
                                            <a className="dropdown-item" href="javascript:void(0);">Delete</a>
                                        </div>
                                    </div>
                                </div>
                                <span className="d-block">Sales</span>
                                <h4 className="card-title mb-1">$4,679</h4>
                                <small className="text-success fw-medium"><i className="bx bx-up-arrow-alt" /> +28.42%</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-6 mb-4">
                        <div className="card">
                            <div className="card-body pb-2">
                                <span className="d-block fw-medium">Profit</span>
                                <h3 className="card-title mb-0">624k</h3>
                                <div id="profitChart" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-6 mb-4">
                        <div className="card">
                            <div className="card-body pb-0">
                                <span className="d-block fw-medium">Expenses</span>
                            </div>
                            <div id="expensesChart" className="mb-2" />
                            <div className="p-3 pt-2">
                                <small className="text-muted d-block text-center">$21k Expenses more than last month</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-3 col-6 mb-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="card-title d-flex align-items-start justify-content-between">
                                    <div className="avatar flex-shrink-0">
                                        <img src="../../iusevolutione/assets/img/icons/unicons/briefcase.png" alt="Credit Card" className="rounded" />
                                    </div>
                                    <div className="dropdown">
                                        <button className="btn p-0" type="button" id="cardOpt1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="bx bx-dots-vertical-rounded" />
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt1">
                                            <a className="dropdown-item" href="javascript:void(0);">View More</a>
                                            <a className="dropdown-item" href="javascript:void(0);">Delete</a>
                                        </div>
                                    </div>
                                </div>
                                <span className="d-block">Transactions</span>
                                <h4 className="card-title mb-1">$14,857</h4>
                                <small className="text-success fw-medium"><i className="bx bx-up-arrow-alt" /> +28.14%</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-md-12 col-lg-8 mb-4">
                <div className="card">
                    <div className="row row-bordered g-0">
                        <div className="col-md-8">
                            <div className="card-header">
                                <h5 className="card-title mb-0">Total Income</h5>
                                <small className="card-subtitle">Yearly report overview</small>
                            </div>
                            <div className="card-body">
                                <div id="totalIncomeChart" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-header d-flex justify-content-between">
                                <div>
                                    <h5 className="card-title mb-0">Report</h5>
                                    <small className="card-subtitle">Monthly Avg. $45.578k</small>
                                </div>
                                <div className="dropdown">
                                    <button className="btn p-0" type="button" id="totalIncome" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="bx bx-dots-vertical-rounded" />
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="totalIncome">
                                        <a className="dropdown-item" href="javascript:void(0);">Last 28 Days</a>
                                        <a className="dropdown-item" href="javascript:void(0);">Last Month</a>
                                        <a className="dropdown-item" href="javascript:void(0);">Last Year</a>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="report-list">
                                    <div className="report-list-item rounded-2 mb-3">
                                        <div className="d-flex align-items-start">
                                            <div className="report-list-icon shadow-sm me-2">
                                                <img src="../../iusevolutione/assets/svg/icons/paypal-icon.svg" width={22} height={22} alt="Paypal" />
                                            </div>
                                            <div className="d-flex justify-content-between align-items-end w-100 flex-wrap gap-2">
                                                <div className="d-flex flex-column">
                                                    <span>Income</span>
                                                    <h5 className="mb-0">$42,845</h5>
                                                </div>
                                                <small className="text-success">+2.34k</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="report-list-item rounded-2 mb-3">
                                        <div className="d-flex align-items-start">
                                            <div className="report-list-icon shadow-sm me-2">
                                                <img src="../../iusevolutione/assets/svg/icons/shopping-bag-icon.svg" width={22} height={22} alt="Shopping Bag" />
                                            </div>
                                            <div className="d-flex justify-content-between align-items-end w-100 flex-wrap gap-2">
                                                <div className="d-flex flex-column">
                                                    <span>Expense</span>
                                                    <h5 className="mb-0">$38,658</h5>
                                                </div>
                                                <small className="text-danger">-1.15k</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="report-list-item rounded-2">
                                        <div className="d-flex align-items-start">
                                            <div className="report-list-icon shadow-sm me-2">
                                                <img src="../../iusevolutione/assets/svg/icons/wallet-icon.svg" width={22} height={22} alt="Wallet" />
                                            </div>
                                            <div className="d-flex justify-content-between align-items-end w-100 flex-wrap gap-2">
                                                <div className="d-flex flex-column">
                                                    <span>Profit</span>
                                                    <h5 className="mb-0">$18,220</h5>
                                                </div>
                                                <small className="text-success">+1.35k</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*/ Total Income */}
            </div>
        </>
    );
}

export default Expenses;